import { Components } from '@ionic/core/dist/types/components';
import { IonText, IonTextarea } from '@ionic/react';
import { FieldConfig, useField } from 'formik';
import React, { HTMLAttributes, ReactElement } from 'react';
import { IonItem } from '../ionic/IonItem';
import { FieldLocked } from '../ui/field-locked';

export interface IonFormFieldProps extends FieldConfig {
  className?: string;
  label: string;
  inputProps?: Partial<Components.IonTextarea> &
    Partial<HTMLAttributes<HTMLIonTextareaElement>> &
    Partial<React.RefAttributes<HTMLIonTextareaElement>>;
}

const IonFormTextareaField = (props: IonFormFieldProps): ReactElement => {
  const { label, inputProps, ...otherProps } = props;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [field, meta, helper] = useField(otherProps as any);

  const errorText = <IonText color="danger">{meta.error}</IonText>;

  let labelColor: string | undefined = 'primary';
  if (
    inputProps?.labelPlacement !== undefined &&
    inputProps?.labelPlacement !== 'floating'
  ) {
    labelColor = undefined;
  }

  return (
    <IonItem lines={'full'} className={props.className}>
      <IonTextarea
        {...field}
        labelPlacement={'floating'}
        autoGrow={true}
        {...inputProps}
        onIonInput={(e) => {
          if (e.detail.value !== undefined) {
            helper.setValue(e.detail.value);
          }
        }}
      >
        <div slot="label">
          <IonText color={labelColor}>
            {label}{' '}
            <FieldLocked
              show={inputProps?.readonly || inputProps?.disabled ? true : false}
            />{' '}
            {errorText}
          </IonText>
        </div>
      </IonTextarea>
    </IonItem>
  );
};

export { IonFormTextareaField };
